// extracted by mini-css-extract-plugin
export default {"mainPage":"styles_mainPage__c8xps"};